const API = "/api";
async function get(p) {
  const r = await fetch(API + p);
  if (!r.ok) throw new Error(`GET ${p} → ${r.status}`);
  return r.json();
}
async function put(p, body) {
  const r = await fetch(API + p, {
    method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(`PUT ${p} → ${r.status}`);
  return r.json();
}
export const api = {
  initialState: () => get("/initial-state"),
  listings: () => get("/listings"),
  getSetting: (k) => get(`/settings/${k}`).catch(() => null),
  putSetting: (k, v) => put(`/settings/${k}`, v),
  putWorkflow: (url, state) => put(`/workflow/${encodeURIComponent(url)}`, state),
};
